import React from 'react';
import { programs } from '../../data/programs';
import { Container } from '../ui/Container';
import { Reveal } from '../ui/Reveal';
import { SectionTitle } from '../ui/SectionTitle';
import { ProgramCard } from './ProgramCard';
export function Programs() {
  return <section id="programs" aria-labelledby="programs-title" className="bg-paper py-20 lg:py-28" data-id="element-240" data-mp="1pkav7s5v3o9h">
      <Container data-id="element-241" data-mp="1phyd9f03tdwf">
        <Reveal className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-242" data-mp="rwskibsn4c2u">
          <SectionTitle id="programs-title" className="lg:col-span-7" data-id="element-243" data-mp="rupnv8wzfkp5">
            Find the right class for your family
          </SectionTitle>
          <p className="text-pretty text-[1.05rem] leading-relaxed text-muted lg:col-span-5 lg:pb-2" data-id="element-244" data-mp="11ugh779t3tnn">
            Every program teaches Olympic-style Taekwondo, shaped for the age and goals of the student. Explore what
            students practice and find the class that suits your family.
          </p>
        </Reveal>

        <ul className="mt-12 grid gap-6 md:grid-cols-2 lg:gap-8" data-id="element-245" data-mp="e3kw0szuvwpd">
          {programs.map(program => <li key={program.id} data-id="element-246" data-mp="25wbnhnm4r0hs">
              <ProgramCard program={program} data-id="element-247" data-mp="20xs2bpfd1sqh" />
            </li>)}
        </ul>
      </Container>
    </section>;
}